import { useState } from 'react';

const FlexboxPlayground = () => {
  const [direction, setDirection] = useState('row');
  const [justify, setJustify] = useState('flex-start');
  const [align, setAlign] = useState('stretch');
  const [wrap, setWrap] = useState('nowrap');
  const [gap, setGap] = useState(10);
  const [itemCount, setItemCount] = useState(4);

  const Select = ({ label, value, onChange, options }) => (
    <div className="mb-3">
      <label className="text-xs font-mono text-[#A1A1AA] block mb-1">{label}</label>
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        className="w-full bg-[#1a1a2e] border border-white/10 text-white text-sm rounded-lg px-3 py-2 focus:outline-none focus:border-[#FF0099]/50"
        data-testid={`flex-select-${label.replace(/\s/g, '-').toLowerCase()}`}
      >
        {options.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  const colors = ['#FF0099', '#1E90FF', '#16FF00', '#FFED00', '#FF5E00', '#C084FC'];

  return (
    <div className="my-6 bg-[#121225]/80 border border-white/10 rounded-2xl p-6" data-testid="flexbox-playground">
      <h3 className="text-lg font-bold font-outfit text-white mb-4">Flexbox Playground</h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <Select label="flex-direction" value={direction} onChange={setDirection} options={['row', 'column', 'row-reverse', 'column-reverse']} />
          <Select label="justify-content" value={justify} onChange={setJustify} options={['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']} />
          <Select label="align-items" value={align} onChange={setAlign} options={['stretch', 'flex-start', 'center', 'flex-end', 'baseline']} />
          <Select label="flex-wrap" value={wrap} onChange={setWrap} options={['nowrap', 'wrap', 'wrap-reverse']} />

          <div className="mb-3">
            <label className="text-xs font-mono text-[#A1A1AA] block mb-1">gap: {gap}px</label>
            <input type="range" min="0" max="40" value={gap} onChange={e => setGap(parseInt(e.target.value))} className="w-full" style={{ accentColor: '#FF0099' }} data-testid="flex-gap-slider" />
          </div>
          <div className="mb-3">
            <label className="text-xs font-mono text-[#A1A1AA] block mb-1">items: {itemCount}</label>
            <input type="range" min="1" max="6" value={itemCount} onChange={e => setItemCount(parseInt(e.target.value))} className="w-full" style={{ accentColor: '#FF0099' }} data-testid="flex-items-slider" />
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="bg-[#0D0D1A] rounded-xl p-3 mb-3 font-mono text-xs text-[#A1A1AA]">
            <span className="syn-tg">.container</span> {'{'}<br />
            &nbsp;&nbsp;<span className="syn-pr">display</span>: <span className="syn-cv">flex</span>;<br />
            &nbsp;&nbsp;<span className="syn-pr">flex-direction</span>: <span className="syn-cv">{direction}</span>;<br />
            &nbsp;&nbsp;<span className="syn-pr">justify-content</span>: <span className="syn-cv">{justify}</span>;<br />
            &nbsp;&nbsp;<span className="syn-pr">align-items</span>: <span className="syn-cv">{align}</span>;<br />
            &nbsp;&nbsp;<span className="syn-pr">flex-wrap</span>: <span className="syn-cv">{wrap}</span>;<br />
            &nbsp;&nbsp;<span className="syn-pr">gap</span>: <span className="syn-cv">{gap}px</span>;<br />
            {'}'}
          </div>

          <div
            className="border border-white/20 rounded-xl p-4 min-h-[200px]"
            style={{
              display: 'flex',
              flexDirection: direction,
              justifyContent: justify,
              alignItems: align,
              flexWrap: wrap,
              gap: `${gap}px`,
            }}
            data-testid="flex-preview"
          >
            {Array.from({ length: itemCount }, (_, i) => (
              <div
                key={i}
                className="rounded-lg flex items-center justify-center font-bold font-outfit text-white text-sm shrink-0"
                style={{
                  backgroundColor: colors[i % colors.length],
                  width: direction.includes('column') ? '100%' : '60px',
                  height: '50px',
                  minWidth: '50px',
                }}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlexboxPlayground;
